module.exports = __webpack_public_path__ + "img/edit-icon.be2908e0.svg";